<div class="link-grid-item">
  <div class="link-grid-item__header">
    <ng-content select="ftr-icon"></ng-content>
    <h3>{{ linkTitle }}</h3>
    @if (label) {
      <span class="link-grid-item__header__label">
        <ftr-badge [text]="label"></ftr-badge>
      </span>
    }
  </div>

  <div class="link-grid-item__content">
    @if (markdown) {
      <div markdown>{{ description }}</div>
    }
    @if (!markdown) {
      <div>{{ description }}</div>
    }
    <div class="link-grid-item__links">
      <ng-content select="a"></ng-content>
    </div>
  </div>
</div>
